import { useLoggedInUserRoles } from '~/components/Auth';
import { useApplicationConfig } from '~/data/applicationConfig';
import { Roles } from '~/data/user';
import { hasOneOfRoles } from '~/services/Permissions';

export const useNewEmployeeViewAccess = () => {
  const userRoles = useLoggedInUserRoles();
  const { applicationConfig } = useApplicationConfig();
  const managerCanCreateEmployee =
    applicationConfig?.fComConfig?.mgrConfig?.fComEnableMgrCreateEmployee ??
    false;

  const canAddEmployeeCandidate = !managerCanCreateEmployee
    ? hasOneOfRoles(userRoles, [Roles.MANAGER])
    : false;

  const canAddEmployee = hasOneOfRoles(userRoles, [
    Roles.HR_ADMIN,
    Roles.HR_ADMIN_LIMITED,
    Roles.RECRUITER,
    Roles.HR_STAFF,
    Roles.HR_SALARY,
    ...(managerCanCreateEmployee ? [Roles.MANAGER] : []),
  ]);

  return {
    canAddEmployee,
    canAddEmployeeCandidate,
  };
};
